import type { WalkthroughConfig } from "../types";

export const reportsWalkthrough: WalkthroughConfig = {
  id: "page-reports",
  title: "Reports & ROI",
  description: "Generate board reports, track KPIs, and prove membership value.",
  type: "page",
  pageRoute: "/reports",
  duration: "1 min",
  category: "pages",
  icon: "BarChart3",
  steps: [
    {
      id: "intro",
      title: "Reports & Insights",
      description: "Generate data-driven reports that prove the value of membership. Track KPIs, analyze trends, and prepare board-ready presentations.",
      placement: "center",
      animation: "fade",
      icon: "BarChart3",
    },
    {
      id: "board",
      title: "Board Reports",
      description: "Auto-generate professional board reports with membership growth, engagement trends, financial summaries, and strategic recommendations.",
      placement: "center",
      animation: "slide-up",
      icon: "FileText",
    },
    {
      id: "roi",
      title: "Member ROI",
      description: "Show members the tangible value they receive — event savings, networking connections, learning credits, and more.",
      placement: "center",
      animation: "scale",
      icon: "TrendingUp",
      nextLabel: "Got it! ✓",
    },
  ],
};
